import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "@/components/portal/ConsultantPortal";
import { portalMeta } from "@/lib/consultant-portal-i18n";

// Consultant portal: noindex, no hreflang/canonical alternates, excluded from sitemaps.
export const Route = createFileRoute("/tr/uzman/giris")({
  ssr: false,
  head: () => portalMeta("Uzman portalı girişi", "Ana verilerinizi yönetmek için OXORY uzman portalına giriş yapın."),
  component: () => <LoginPage locale="tr" />,
});
